// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingPage_root__gMaPP","listings":"ListingPage_listings__sv9zt","summary":"ListingPage_summary__NIIga"};